import dayjs from 'dayjs';
import { useShiftsAssignment } from '@libs/store/shifts';
import { useNotification } from '@libs/snackbar';
import { parseError } from '@libs/api/errors';
import { UnassignDialog } from './unassignDialog';

type CalendarUnassignDialogProps = {
  onAction?: () => void;
};
export function CalendarUnassignDialog({ onAction }: CalendarUnassignDialogProps) {
  const { unassignShift, closeShiftUnassignDialog, currentShift, unassignDialogOpen } = useShiftsAssignment();
  const { showSuccessIntl, showError } = useNotification();

  const unassign = async (reason: string, reasonComment: string) => {
    if (!currentShift) return;
    await unassignShift(currentShift.id, { reason, reasonComment })
      .then(() => {
        onAction && onAction();
        closeShiftUnassignDialog();
        showSuccessIntl('shifts.unassignSuccessful');
      })
      .catch((error: unknown) => showError(parseError(error).message));
  };
  return (
    <>
      {currentShift && (
        <UnassignDialog
          open={unassignDialogOpen}
          shift={{
            shiftStart: dayjs(currentShift?.startDate).toDate(),
            shiftLength: dayjs(currentShift?.endDate).diff(dayjs(currentShift?.startDate)),
            qualifications: currentShift?.nurseQualifications || [],
            assigneeName: currentShift?.staff ? currentShift?.staff.fullName : '',
          }}
          onClose={() => closeShiftUnassignDialog()}
          onSubmit={unassign}
          loading={false}
        />
      )}
    </>
  );
}
